import { useStoreActions, useStoreState } from "easy-peasy";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "@material-ui/core/Collapse";
import "./Drower.scss";
const Drower = () => {
  const menuActive = useStoreState((state) => state.something.menuActive);
  const setMenuActive = useStoreActions(
    (state) => state.something.setMenuActive
  );
  const paths = useStoreState((state) => state.path.paths);
  const careerpaths = useStoreState((state) => state.careerPath.paths);

  const [first, setFirst] = useState(false);
  const [second, setSecond] = useState(false);
  const [third, setThird] = useState(false);
  const [forth, setForth] = useState(false);

  return (
    <div className={menuActive ? "drower activeDrower" : "drower"}>
      <div className="drowerOverlay"></div>
      <div className="drowerList">
        <ul>
          <li className="drowerLi">
            <a href="javascript:void(0)" onClick={() => setFirst(!first)}>
              О компании
              <span className="material-icons drowerIconExpand">
                {!first ? "add" : "remove"}
              </span>
            </a>
            <Collapse in={first}>
              <ul>
                <div className="drowerDivider"></div>
                <li className="innerDrowerLi">
                  <Link to="/about" onClick={() => setMenuActive(false)}>
                    О компании
                  </Link>
                </li>
                <div className="drowerDivider"></div>
                <li className="innerDrowerLi">
                  <Link to="/management" onClick={() => setMenuActive(false)}>
                    Руководство
                  </Link>
                </li>
                <div className="drowerDivider"></div>
                <li className="innerDrowerLi">
                  <Link to="/documents" onClick={() => setMenuActive(false)}>
                    Документы
                  </Link>
                </li>
                <div className="drowerDivider"></div>
                <li className="innerDrowerLi">
                  <Link to="/news" onClick={() => setMenuActive(false)}>
                    Новости
                  </Link>
                </li>
                <div className="drowerDivider"></div>
                <li className="innerDrowerLi">
                  <Link to="/purchase" onClick={() => setMenuActive(false)}>
                    Закупки
                  </Link>
                </li>
                <div className="drowerDivider"></div>
                <li className="innerDrowerLi">
                  <Link to="/security" onClick={() => setMenuActive(false)}>
                    Охрана труда
                  </Link>
                </li>
                <div className="drowerDivider"></div>
                <li className="innerDrowerLi">
                  <Link to="/actives" onClick={() => setMenuActive(false)}>
                    Непрофильные активы
                  </Link>
                </li>
              </ul>
            </Collapse>
          </li>
          <div className="drowerDivider"></div>
          <li className="drowerLi">
            <a href="javascript:void(0)" onClick={() => setSecond(!second)}>
              Покупателям
              <span className="material-icons drowerIconExpand">
                {!second ? "add" : "remove"}
              </span>
            </a>
            <Collapse in={second}>
              <ul>
                <div className="drowerDivider"></div>
                <li className="innerDrowerLi">
                  <Link to="/deals" onClick={() => setMenuActive(false)}>
                    Акции
                  </Link>
                </li>
                <div className="drowerDivider"></div>
                <li className="innerDrowerLi">
                  <Link to="/bonus" onClick={() => setMenuActive(false)}>
                    Бонусная программа
                  </Link>
                </li>
                <div className="drowerDivider"></div>
                <li className="innerDrowerLi">
                  <Link to="/privilege" onClick={() => setMenuActive(false)}>
                    Льготное обеспечение
                  </Link>
                </li>
                <div className="drowerDivider"></div>
                <li className="innerDrowerLi">
                  <Link to="/production" onClick={() => setMenuActive(false)}>
                    Изготовление лекарств
                  </Link>
                </li>
                <div className="drowerDivider"></div>
                <li className="innerDrowerLi">
                  <Link to="/optica" onClick={() => setMenuActive(false)}>
                    Оптика
                  </Link>
                </li>
                <div className="drowerDivider"></div>
                <li className="innerDrowerLi">
                  <Link to="/legal" onClick={() => setMenuActive(false)}>
                    Оптовым покупателям
                  </Link>
                </li>
              </ul>
            </Collapse>
          </li>
          <div className="drowerDivider"></div>
          <li className="drowerLi">
            <Link to="/rent" onClick={() => setMenuActive(false)}>
              аренда
            </Link>
          </li>
          <div className="drowerDivider"></div>
          <li className="drowerLi">
            <Link to="/storenetwork" onClick={() => setMenuActive(false)}>
              аптечная сеть
            </Link>
          </li>
          {careerpaths && careerpaths.length > 0 && (
            <>
              <div className="drowerDivider"></div>
              <li className="drowerLi">
                <a href="javascript:void(0)" onClick={() => setForth(!forth)}>
                  Карьера
                  <span className="material-icons drowerIconExpand">
                    {!forth ? "add" : "remove"}
                  </span>
                </a>
                <Collapse in={forth}>
                  <ul>
                    {careerpaths.map((elem, ind) => (
                      <React.Fragment key={ind}>
                        <div className="drowerDivider"></div>
                        <li className="innerDrowerLi">
                          <Link
                            to={"/career/" + elem.path}
                            onClick={() => setMenuActive(false)}
                          >
                            {elem.title}
                          </Link>
                        </li>
                      </React.Fragment>
                    ))}
                  </ul>
                </Collapse>
              </li>
            </>
          )}
          {paths && paths.length > 0 && (
            <>
              <div className="drowerDivider"></div>
              <li className="drowerLi">
                <a href="javascript:void(0)" onClick={() => setThird(!third)}>
                  Актуальное
                  <span className="material-icons drowerIconExpand">
                    {!third ? "add" : "remove"}
                  </span>
                </a>
                <Collapse in={third}>
                  <ul>
                    {paths.map((elem, ind) => (
                      <React.Fragment key={ind}>
                        <div className="drowerDivider"></div>
                        <li className="innerDrowerLi">
                          <Link
                            to={"/extra/" + elem.path}
                            onClick={() => setMenuActive(false)}
                          >
                            {elem.title}
                          </Link>
                        </li>
                      </React.Fragment>
                    ))}
                  </ul>
                </Collapse>
              </li>
            </>
          )}
          <div className="drowerDivider"></div>
          <li className="drowerLi">
            <Link to="/contacts" onClick={() => setMenuActive(false)}>
              контакты
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Drower;
